import React from 'react'
import RealState from '../Assets/Images/Industries/construction.png'
import TechStartup from '../Assets/Images/Industries/service-provider.png'
import RenewableEnergy from '../Assets/Images/Industries/solar.jpg'
import Interior from '../Assets/Images/Industries/interior.png'
import Manufacturing from '../Assets/Images/Industries/manufacturing.png'
import MarketingAgency from '../Assets/Images/Industries/marketing-agency.png'
import eCommerce from '../Assets/Images/Industries/ecommerce.png'
import Logistics from '../Assets/Images/Industries/logistics.png'
import ProfessionalServices from '../Assets/Images/Industries/Hr.png'
import SMEs from '../Assets/Images/Industries/sme.png'


function Industries() {

    const industries = [
        { image: RealState, alt: 'Real Estate', title: 'Construction & Real Estate' },
        { image: Interior, alt: 'Interior Design', title: 'Interior Design & Fit Out Firms' },
        { image: RenewableEnergy, alt: 'Renewable Energy', title: 'Renewable Energy & Solar Providers' },
        { image: Manufacturing, alt: 'Manufacturing', title: 'Manufacturing & Engineering Companies' },
        { image: eCommerce, alt: 'E-commerce Retail', title: 'E-commerce & Retail Brands' },
        { image: TechStartup, alt: 'Tech Startup', title: 'Tech Startups & SaaS Providers' },
        { image: MarketingAgency, alt: 'Marketing Agency', title: 'Marketing & Digital Agencies' },
        { image: Logistics, alt: 'Logistics', title: 'Logistics & Supply Chain Businesses' },
        { image: ProfessionalServices, alt: 'Professional Services', title: 'Professional Services' },
        { image: SMEs, alt: 'SMEs', title: 'Small to Medium Enterprises' },
    ];
    
    return (
        <>
            <div className="sbst-offer-area pd-top-100">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-xl-7 col-lg-10">
                            <div className="section-title text-center">
                                <h2 className="title wow  fadeInUp animated" data-wow-duration="0.6s" data-wow-delay="0.1s">Who We <span>Serve</span></h2>
                                <p className="wow  fadeInUp animated text-center" data-wow-duration="0.6s" data-wow-delay="0.2s">FusionHub is more than a service provider we are your trusted ally in a fast-evolving world, fusing technology and talent to help you stay ahead.</p>
                            </div>
                        </div>
                    </div>
                    <div className="row custom-gutters-28 justify-content-center">
                        {industries.map((industry, index) => (
                            <div className="col-xl-3 col-lg-4 col-sm-6" key={index}>
                                <div className="single-offer wow  fadeInUp animated" data-wow-duration="0.6s" data-wow-delay="0.1s">
                                    <div className="media">
                                        <img src={industry.image} alt={industry.alt} />
                                        <div className="media-body align-self-center">
                                            <h6>{industry.title}</h6>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </>
    )
}

export default Industries
